import { createSelector } from "reselect";

import { CrudBuilderState } from "seneca-common/utils/apiStates";
import { composeSelectors } from "seneca-common/utils/selectors/compose-selectors";

import SectionStatsStateSlice, {
  SectionStats
} from "../../../models/state/sectionStats";
import * as metaSelectors from "./meta";
import * as statsSelectors from "./stats";
import { SectionStatsMetaSelectors, SectionStatsSelectors } from "./types";

export function getSectionStats(state: SectionStatsStateSlice): SectionStats {
  return state.stats;
}

export function getSectionStatsMeta(
  state: SectionStatsStateSlice
): CrudBuilderState {
  return state.meta as unknown as CrudBuilderState;
}

export const getStudiedSectionIds = createSelector(getSectionStats, stats =>
  stats.keySeq()
);

// @ts-ignore
export const {
  hasSectionStat,
  getSectionStat,
  getTimesStudied,
  getTotalStudyTime,
  getBestScore,
  getLastScore,
  getSpacing,
  getLastStudied,
  getModuleIdsIncorrectLast,
  getNumberOfModuleIdsIncorrect,
  getAverageScore,
  getSectionsStats
}: SectionStatsSelectors<SectionStatsStateSlice> = composeSelectors(
  getSectionStats,
  statsSelectors
);

// @ts-ignore
export const {
  allSectionStatsForCourseFetchErrored,
  allSectionStatsForCourseFetchFinished,
  allSectionStatsForCourseFetchSucceeded,
  allSectionStatsForCourseNeedsFetching
}: SectionStatsMetaSelectors<SectionStatsStateSlice> = composeSelectors(
  getSectionStatsMeta,
  metaSelectors
);
